var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJaaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13.9762C12.7811 12.3783 10.6089 11.2598 8.19111 10.8275C7.04833 10.6301 6 11.5324 6 12.6885V18.5536C6 20.1327 6.68 20.9598 7.615 21.082C9.97611 21.3828 12.12 22.3509 13.8767 23.7795C14.2072 24.0521 14.7456 24.0803 15.0761 23.8171C16.8422 22.3791 19.005 21.3922 21.385 21.0914C22.2728 20.9692 23 20.0951 23 19.1927V12.6885C23 11.5324 21.9517 10.6301 20.8089 10.8275C18.3911 11.2598 16.2189 12.3783 14.5 13.9762ZM14.5 10.6395C16.0678 10.6395 17.3333 9.38001 17.3333 7.81975C17.3333 6.25949 16.0678 5 14.5 5C12.9322 5 11.6667 6.25949 11.6667 7.81975C11.6667 9.38001 12.9322 10.6395 14.5 10.6395Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaaq);
export default __webpack_public_path__ + "static/media/jaaq.4e354c83a910a3c8bc831ea24321f15d.svg";
export { ForwardRef as ReactComponent };